<template>
    <div class="body-info body-content-description themed-scrollbar">
        <p class="content-description"> {{ kStrings.kRECIPE_TIME_PREP + ':' }} <span > {{ modalData.content.recipeInfo.timeBaking }} </span> </p>
        <p class="content-description"> {{ kStrings.kRECIPE_TIME_COOKING + ':' }}  <span> {{ modalData.content.recipeInfo.timePreparation }} </span> </p>
        <h4 v-if="modalData.content.ingredients" class="content-description"> {{ kStrings.kRECIPE_INGREDIENTS + ':'  }} </h4>
        <ul v-if="modalData.content.ingredients" class="content-list">
            <li v-for="(item, index) in modalData.content.ingredients" :key="'ingredient-'+index"> {{ item }} </li>
        </ul>
        <h4 v-if="modalData.content.instructions" class="content-description title"> {{ kStrings.kRECIPE_MODE_PREP + ':'  }} </h4>
        <ul v-if="modalData.content.instructions" class="content-list">
            <li v-for="(item, index) in modalData.content.instructions" :key="'instruction-'+index" class="list-item">
                <!--                            <p class="step"> {{ index+1 + 'º' + '&nbsp;' + kStrings.kGLOB_STEP  + ':' }} </p>-->
                <p class="step"> {{ kStrings.kGLOB_STEP + '&nbsp;' + parseInt(index+1)  + ':' }} </p>
                {{ item }}
            </li>
        </ul>
        <p v-if="modalData.content.recipeInfo.observation" class="content-description"> {{ kStrings.kOBSERVATIONS + ':' }}  <span> {{ modalData.content.recipeInfo.observation }} </span> </p>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

export default {
    store,
    name: 'RecipeDescription',
    components: {},
    props: {
        
    },
    data() {
        return {}
    },
    computed: {
        kStrings() {
            return this.$store.getters.kStrings;
        },
        modalData() {
            return this.$store.getters.modalData;
        },
    },
    watch: {},
    created() {
    },
    mounted() {
    },
    methods: {}
};
</script>

<style scoped>

</style>